// extracted by mini-css-extract-plugin
module.exports = {"modal":"e1MlY","input":"V9U2y","switch":"iGyi0","actions":"FKTSe"};